exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.login-container[data-v-33144c5c] {\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n}\n.login-form[data-v-33144c5c] {\n    width: 100%;\n    max-width: 415px;\n    margin-top: 10%;\n}\n.button-container[data-v-33144c5c] {\n    width: 100%;\n    display: inline-flex;\n    justify-content: space-between;\n}\n", ""]);

// exports
